// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ExportCatalogContainer .alertText {\n  font-size: 0.65rem; }\n", "",{"version":3,"sources":["webpack://./src/components/ExportCatalog/ExportCatalog.scss"],"names":[],"mappings":"AAAA;EAEQ,kBAAkB,EAAA","sourcesContent":[".ExportCatalogContainer{\n    .alertText{\n        font-size: 0.65rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
